3<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="fixed inset-0 overflow-hidden" @close="close()">
            <div class="absolute inset-0 overflow-hidden">
                <DialogOverlay class="absolute inset-0 bg-gray-500 opacity-75"/>

                <div class="fixed inset-y-0 pl-16 max-w-full right-0 flex">
                    <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700"
                                     enter-from="translate-x-full" enter-to="translate-x-0"
                                     leave="transform transition ease-in-out duration-500 sm:duration-700"
                                     leave-from="translate-x-0" leave-to="translate-x-full">
                        <div class="w-screen max-w-2xl">
                            <form class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl"
                                  @submit.prevent="submit">
                                <div class="flex-1 h-0 overflow-y-auto">
                                    <div class="py-6 px-4 bg-amaze-coral sm:px-6">
                                        <div class="flex items-center justify-between">
                                            <DialogTitle class="text-lg text-white font-bold" v-if="form.id">
                                                Update Supplier Invoice
                                            </DialogTitle>
                                            <DialogTitle class="text-lg text-white font-bold" v-else>
                                                Create Supplier Invoice
                                            </DialogTitle>
                                            <div class="ml-3 h-7 flex items-center">
                                                <button type="button"
                                                        class="bg-amaze-coral rounded-md text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                        @click="close()">
                                                    <span class="sr-only">Close panel</span>
                                                    <XIcon class="h-6 w-6" aria-hidden="true"/>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="mt-1">
                                            <p class="text-sm text-white">
                                                Get started by filling in the information below to create a new
                                                supplier invoice.
                                            </p>
                                        </div>
                                    </div>
                                    <SlideOutErrors :show="showErrors === true"/>
                                    <div class="flex-1 flex flex-col justify-between">
                                        <div class="px-4 divide-y divide-gray-200 sm:px-6">
                                            <div class="mt-6 grid grid-cols-2 gap-4">
                                                <div class="col-span-2">
                                                    <h3 class="text-lg leading-6 font-medium text-gray-900">Supplier
                                                        Information</h3>
                                                </div>
                                                <div class="col-span-2">
                                                    <label for="supplier"
                                                           class="block text-sm text-gray-900 required">
                                                        Supplier
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="supplier" v-model="form.organisation_id"
                                                                :class="{'border-red-500': form.errors.organisation_id}"
                                                                class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected v-html="'Select a supplier'"></option>
                                                            <option v-for="(supplier,index) in suppliers"
                                                                    v-html="supplier.name" :value="supplier.id"></option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="recevied_at"
                                                           class="block text-sm text-gray-900 required">
                                                        Received Date
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="date" v-model="form.received_at" id="received_at"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.received_at}"
                                                        />
                                                    </div>
                                                </div>

                                                <div>
                                                    <label for="invoice_number"
                                                           class="block text-sm text-gray-900 required">
                                                        Invoice Number
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" id="invoice_number" v-model="form.invoice_number"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.invoice_number}"
                                                        />
                                                    </div>
                                                </div>

                                                <div>
                                                    <label for="invoice_amount"
                                                           class="block text-sm text-gray-900 required">
                                                        Total Invoice Amount
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" id="invoice_amount" v-model="form.amount"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.amount}"
                                                        />
                                                    </div>
                                                </div>

                                                <div>
                                                    <label for="invoice_currency"
                                                           class="block text-sm text-gray-900 required">
                                                        Invoice Currency
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="invoice_currency" v-model="form.currency_id"
                                                                :class="{'border-red-500': form.errors.currency_id}"
                                                                class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected
                                                                    v-html="'Select a currency'"></option>
                                                            <option v-for="(currency,index) in currencies"
                                                                    v-html="currency.symbol + ' - ' + currency.name"
                                                                    :value="currency.id"></option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div>
                                                    <label for="invoice_gbp_amount"
                                                           class="block text-sm text-gray-900 required">
                                                        Total GBP Amount
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" id="invoice_gbp_amount" v-model="form.gbp_amount"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.gbp_amount}"
                                                        />
                                                    </div>
                                                </div>

                                                <div v-if="updating === false">
                                                    <label for="gbp_amount_to_current_project"
                                                           class="block text-sm text-gray-900 required">
                                                        GBP Amount Assigned To Current Project
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" id="gbp_amount_to_current_project" v-model="form.gbp_amount_to_current_project"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.gbp_amount_to_current_project}"
                                                        />
                                                    </div>
                                                </div>

                                                <div class="col-span-2">
                                                    <label for="notes"
                                                           class="block text-sm text-gray-900">
                                                        Notes
                                                    </label>
                                                    <div class="mt-1">
                                                        <quill-editor content-type="html"
                                                                      v-model:content="form.notes"
                                                                      :class="{'border-red-500': form.errors.notes}"
                                                                      class="min-h-[150px] mt-1 block w-full bg-white border border-gray-300 shadow-sm py-2 px-3"
                                                                      theme="snow"></quill-editor>
                                                    </div>
                                                </div>
                                                <div class="col-span-2">
                                                    <label
                                                           class="block text-sm text-gray-900">
                                                        Attach Invoice
                                                    </label>
                                                    <div class="mt-1">
                                                        <dd class="my-2 text-sm text-gray-900" v-if="form.invoices.length > 0">
                                                            <ul role="list" class="border border-gray-200 rounded-md divide-y divide-gray-200">
                                                                <li class="pl-3 pr-4 py-3 flex items-center justify-between text-sm" v-for="(invoice,index) in form.invoices">
                                                                    <div class="w-0 flex-1 flex items-center">
                                                                        <PaperClipIcon class="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                        <span class="ml-2 flex-1 w-0 truncate"> {{ invoice }} </span>
                                                                    </div>
                                                                    <div class="ml-4 flex-shrink-0">
                                                                        <a :href="route('frontend.project.supplier-invoice.invoice.download', [form.project_id, form.id, invoice])" class="font-medium text-pitch-purple hover:text-light-pitch-purple"> <DownloadIcon class="w-4 h-4" /> </a>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </dd>
                                                        <label class="w-full mb-4 flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg tracking-wide uppercase border border-blue cursor-pointer">
                                                            <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                                <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                                                            </svg>
                                                            <span v-if="form.file_uploads.length  === 0" class="mt-2 text-base leading-normal">Select a file</span>
                                                            <span v-else>{{ form.file_uploads.length }} file<span v-if="form.file_uploads.length > 1">s</span> selected for upload</span>
                                                            <input type='file' class="hidden" multiple @change="prepareFileUpload($event)" />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="flex-shrink-0 px-4 py-4 flex justify-end">
                                    <button type="button"
                                            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                            @click="close()">
                                        Close
                                    </button>
                                    <button :disabled="form.processing || !form.isDirty" type="submit"
                                            class=" ml-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm rounded-md text-white bg-amaze-coral hover:bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-200">
                                        <span v-if="updating === true">Update</span>
                                        <span v-else>Save</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script>
import {ref, reactive} from 'vue'
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {XIcon} from '@heroicons/vue/outline'
import {LinkIcon, PlusSmIcon, QuestionMarkCircleIcon, ExclamationCircleIcon, UploadIcon, PaperClipIcon, DownloadIcon} from '@heroicons/vue/solid'
import {useForm, usePage} from '@inertiajs/vue3'
import Inertia from '@inertiajs/vue3'
import SlideOutErrors from "@/Components/SlideOutErrors.vue";
import {mapState} from "vuex";
import {emitter} from "@/eventHub";


export default {
    components: {
        SlideOutErrors,
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        LinkIcon,
        PlusSmIcon,
        QuestionMarkCircleIcon,
        ExclamationCircleIcon,
        XIcon,
        UploadIcon,
        PaperClipIcon,
        DownloadIcon
    },
    computed: {
        ...mapState({
            suppliers: state => state.supplierinvoice.suppliers ?? null,
            currencies: state => state.supplierinvoice.currencies ?? null,
        }),
    },
    setup(prop, context) {

        const show = ref(false)

        const showErrors = ref(false)

        const updating = false;

        const project = usePage().props.project;

        const form = useForm({
            id: null,
            project_id: null,
            organisation_id: "",
            received_at: null,
            invoice_number: null,
            amount: null,
            currency_id: "",
            gbp_amount: null,
            notes: "",
            invoices: [],
            file_uploads: [],
            gbp_amount_to_current_project: null
        })

        function submit() {
            if (this.updating) {
                this.form.post(route('frontend.project.supplier-invoice.invoice.update', [usePage().props.project.id, this.form.id]), {
                    onSuccess: page => {
                        this.show = false;
                        this.showErrors = false;
                        this.form.reset();
                    },
                    onError: errors => {
                        this.showErrors = true;
                    }
                });
            } else {
                this.form.post(route('frontend.project.supplier-invoice.store', [usePage().props.project.id]), {
                    onSuccess: page => {
                        this.show = false;
                        this.showErrors = false;
                        this.form.reset();
                    },
                    onError: errors => {
                        this.showErrors = true;
                    }
                });
            }
        }

        function close() {
            this.form.reset();
            this.form.clearErrors();
            this.updating = false;
            this.show = false;
        }

        function open() {
            this.$store.dispatch('supplierinvoice/getData', {
                project_id: project.id
            });
            if (typeof project !== 'undefined') {
                this.form.project_id = project.id
            }
            this.form.clearErrors();
            this.show = true;
        }

        const emitter = emitter;

        return {
            show,
            form,
            submit,
            updating,
            close,
            open,
            showErrors,
            emitter,
        }
    },
    mounted() {
        emitter.on('openSupplierInvoiceSlideout', () => {
            this.open();
        });

        emitter.on('editSupplierInvoiceSlideout', (supplier_invoice) => {
            this.updating = true;
            this.form.id = supplier_invoice.id;
            this.form.organisation_id = supplier_invoice.organisation_id
            this.form.received_at = supplier_invoice.received_at
            this.form.amount = supplier_invoice.amount
            this.form.gbp_amount = supplier_invoice.gbp_amount
            this.form.currency_id = supplier_invoice.currency_id
            this.form.invoices = supplier_invoice.invoices ?? []
            this.form.notes = supplier_invoice.notes
            this.form.invoice_number = supplier_invoice.invoice_number
            this.form.project_id = supplier_invoice.project_id
            this.open();
        })

    },
    methods: {
        prepareFileUpload(event) {
            this.form.file_uploads = event.target.files
        }
    }
}
</script>
